
<template>
    
        <mars-view class="answer-item-container" @click.native.stop="goDetail"><mars-view class="answer-title-box"><mars-view class="answer-title">{{ answerInfo.qaQuestion }}</mars-view><mars-view v-if="isSelected" class="selected"></mars-view></mars-view><lawyer-card :lawyer-info="lawyerInfo"></lawyer-card><mars-view class="answer-content lineclamp2">
        {{ answerInfo.qaAnswer }}
        <mars-view class="content-more">
            ...全文
        </mars-view></mars-view><mars-view v-if="pubTime" class="answer-time-box">
        回答于<mars-text class="time">{{ pubTime }}</mars-text></mars-view></mars-view>
    
</template>

<script>
import log from '../../../static/utils/ubcLog';
import lawyerCard from "./answer-lawyer-card.vue";
import { act } from '../../../static/utils/navigate';
import { formatTimeToDate } from '../../../pages/qalandpage/utils/util.js';
export default {
  components: {
    'lawyer-card': lawyerCard
  },
  props: {
    // 问答信息
    answerInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    // 是否是精选
    isSelected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // 律师信息
    lawyerInfo() {
      return this.answerInfo && this.answerInfo.expertInfo || {};
    },
    // 发布时间
    pubTime() {
      let {
        pubTime
      } = this.answerInfo;
      if (!pubTime) {
        return '';
      }
      return pubTime.replace(/\./g, '-');
    }
  },
  data() {
    return {};
  },
  methods: {
    // 跳转订单详情页
    goDetail() {
      let {
        qid
      } = this.answerInfo || {};
      if (!qid) {
        return;
      }
      act({
        target: `/question/${qid}?fr=law-regulation`,
        type: 'url'
      });
    }
  }
};
</script>

<style scoped>
.answer-item-container {
  background-color: #fff;
  padding: 5.07vw 0 4.35vw;
  border-bottom: 0.16vw solid #edeef0;
}
.answer-item-container .lineclamp2 {
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.answer-item-container .answer-title-box {
  display: flex;
  align-items: center;
  font-family: PingFang SC;
  font-weight: 700;
  padding-bottom: 3.38vw;
}
.answer-item-container .answer-title-box .answer-title {
  width: 0;
  flex: 1;
  font-size: 4.35vw;
  color: #1e1f24;
  line-height: 4.35vw;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.answer-item-container .answer-title-box .selected {
  font-size: 2.66vw;
  color: #36f;
  line-height: 3.86vw;
  border: 2px solid rgba(51, 102, 255, 0.4);
  border-radius: 0.97vw;
}
.answer-item-container .answer-content {
  position: relative;
  margin-top: 0.85vw;
  font-family: PingFang SC;
  font-size: 3.38vw;
  color: #1e1f24;
  line-height: 5.56vw;
}
.answer-item-container .answer-content .content-more {
  position: absolute;
  bottom: 0;
  right: 0;
  color: #50525c;
  font-family: PingFang SC;
  font-size: 3.38vw;
  line-height: 5.56vw;
  background: #fff;
}
.answer-item-container .answer-content .content-more::before {
  content: "";
  width: 0.6rem;
  height: 100%;
  position: absolute;
  left: -0.6rem;
  top: 0;
  background: linear-gradient(to right, rgba(255, 255, 255, 0), #ffffff);
}
.answer-item-container .answer-time-box {
  margin-top: 2.54vw;
  font-family: PingFang SC;
  font-size: 3.38vw;
  color: #b7b9c1;
  line-height: 3.38vw;
}
.answer-item-container .answer-time-box .time {
  padding-left: 1.13vw;
}

</style>
